import { React, useState, useEffect } from 'react'
import DatePicker from 'react-datepicker';
import { format, parse } from 'date-fns';
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { APIConstants, CommonAPIConstants, RemittanceConstants } from '../utilities/Constants';
import { faSpinner, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel, faFilePdf, faFile } from '@fortawesome/free-regular-svg-icons'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import RemittanceClaimCounts from './RemittanceClaimCounts';
import "../css/PagesCommonStyle.css"
import { useParams } from 'react-router-dom'
import Draggable from 'react-draggable'
import { Link } from 'react-router-dom';

const GeneralDocuments = () => {


    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [unprocessedFile, setunprocessedFile] = useState([]);
    const [processedFile, setprocessedFile] = useState([]);
    const [remittanceData, setRemittanceData] = useState([]);
    const [selectedFile, setselectedFile] = useState('');
    const [fileExtension, setFileExtension] = useState('');
    const [base64File, setBase64File] = useState('');
    const [showDataModal, setShowDataModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');
    const [hasFetched, setHasFetched] = useState(false);

    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [generalDocsData, setGeneralDocsData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAllRowsChecked, setSelectAllRowsChecked] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectPatientId, setSelectPatientId] = useState('');
    const [selectDocumentId, setSelectDocumentId] = useState('');

    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);




    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;


    const sAuthToken = useSelector((state) => state.user.user.sAuthToken);

    const { id } = useParams();
    const DemoGraphyData = useSelector((state) => state.user.demoDetails);
    const PatientID = DemoGraphyData?.PatientId;
    console.log('GeneralDOCSPatientId:>>>>>>', id);




    useEffect(() => {
        document.title = 'Patient Portal - General Documents'

        // Set the default last 7 days' date range
        const today = new Date();
        const FromDay = new Date();
        FromDay.setDate(FromDay.getDate() - 7);
        const FormttedToDate = format(today, 'MM/dd/yyyy');

        setStartDate(FromDay);
        setEndDate(FormttedToDate);

    }, []);




    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);

            console.log("Selected start date:", formattedDate);
            setEndDate(formattedDate);
            setIsStartOpen(false)
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };






    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setEndDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );












    const formatDOSDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };



    const handleCloseModals = () => {
        // Close all modals

        setShowDataModal(false)
        setShowConfirmModal(false)

    };








    const handleGetGeneralDocsData = async () => {



        var inputStruct = {

            PatientID: PatientID,
            PracticeID: userPracticeID,
            FromDate: startDate,
            ToDate: endDate,
            OffSet: userData.DefaultTimeZoneOffSet


        };

        var myInput = JSON.stringify({ PatDetails: inputStruct })
        console.log("INPUT: ", myInput);

        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetGeneralDocs}?sInputJSON=${myInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setGeneralDocsData(parsedData)

                console.log("GetGeneralDocs of" + CommonAPIConstants.GetGeneralDocs, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }




    useEffect(() => {
        if (!hasFetched && startDate && endDate) {

            handleGetGeneralDocsData();
            setHasFetched(true);
        }
    }, [startDate, endDate, hasFetched]);







    
  const handleDeleteModal = async (item) => {
     
    setSelectPatientId(item.PatientID)
    setSelectDocumentId(item.DocumentID)
    setShowConfirmModal(true)

  }





    
    const handleDelete =  () => {


    
        const objClaim = {
          
          PatientID : selectPatientId,
          PracticeID : userPracticeID,
          DocumentID: selectDocumentId ,
        
  
        }
  
       
      console.log("objClaim", objClaim);
    
      var sInputJSON = JSON.stringify({PatDetails:objClaim});
      console.log("inputRow of" + CommonAPIConstants.DeleteDocument, sInputJSON);
    
   
  
  
      
      const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.DeleteDocument}?sInputJSON=${sInputJSON}`;
  
      console.log("URL: ", url);
  
      fetch(url, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        }
      })
       
      .then(data => {

     
        setShowConfirmModal(false)
        console.log("Response of" + CommonAPIConstants.DeleteDocument, data);

  
        if(data.status === 200)
        {
          handleGetGeneralDocsData()
        }

      



      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }
  






    const GetPDF = (item) => {

        console.log("PDF Data", item);


        const url = item.DocumentWebPath;
        window.open(url, '_blank');



    };







    const handleFileChange = (e) => {
        const files = e.target.files; // Get all selected files
        if (files.length > 0) {
            Array.from(files).forEach((file) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64 = reader.result.split(',')[1]; // Get Base64 content
                    setselectedFile(file.name)
                    setBase64File(base64)
                };
                reader.readAsDataURL(file); // Read file as Base64
            });
        }

        console.log('Base64 String:------', base64File, selectedFile);
    };






    useEffect(() => {
        console.log('Base64 String:------', base64File, selectedFile?.File);
        // handleUploadingFile()

    }, [base64File, selectedFile])




    const handleUploadingFile = async (e) => {
        setIsUploading(true)



        const inpuJson = {

            PatientID: PatientID,
            FileContent: base64File,
            DocumentName: selectedFile,
            PracticeID: userPracticeID,


        }


        const myInput = JSON.stringify({ PatDetails: inpuJson });
        const inputData = JSON.stringify(myInput)
        console.log("Input of Process File  " + CommonAPIConstants.UpdatedDocument, inputData);

        try {
            const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.UpdatedDocument, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`
                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                setIsUploading(false);
                return;
            }

            const responseData = await response.json();
            console.log("Response Uploading File", responseData);
            setIsUploading(true)

           
            setTimeout(() => {
                setIsUploading(false);
                handleGetGeneralDocsData();

            }, 1000);



        } catch (error) {
            console.error('An error occurred:', error);
            setIsUploading(false)
        }
    };





    // Function to handle input changes
    const handleInputChange = (index, newValue) => {
        setGeneralDocsData((prevData) =>
            prevData.map((item, i) =>
                i === index ? { ...item, Results: newValue } : item
            )
        );
    };






    const handleRowCheckboxChange = (index, item) => {
        console.log('Selected Rows:', item);
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedRows([...selectedRows, index]);

        }
        setSelectAllRowsChecked(false);
    }




    

    const handleRowClick = (index) => {
        setActiveRow(index);
      };
    
  



    return (
        <>

            <div className='Gen-container'>


            <header className='hv-pagehead'>
                <div>
                    <h1 className='hv-pagehead__title'>General Documents</h1>
                    <div className='hv-pagehead__sub'>Patient portal uploads and shared files</div>
                </div>
            </header>

                <div className='upload-container mt-2'>
                    <div className='border-container'>


                        <div className="mb-3" style={{ margin: '50px', marginLeft: '400px' }}>

                            <input className="form-control form-control-sm" type="file" id="formFileMultiple" multiple style={{ width: '300px' }}
                                onChange={handleFileChange}

                            />

                        </div>





                        <button className='btn-style3' style={{ marginLeft: '550px' }} onClick={(e) => handleUploadingFile(e)} >Upload</button>

                        {isUploading && (
                            <FontAwesomeIcon style={{ marginLeft: '10px' }} className='rotating-icon' icon={faSpinner} />
                        )}

                    </div>

                </div>
        

            <div className='d-flex mt-5'>
                <div className="datepicker-container" style={{ marginLeft: '500px', zIndex: 10 }}>
                    <label>From:</label>
                    <DatePicker
                        selected={startDate ? new Date(startDate) : null}
                        onChange={handleStartDateChange}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}

                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                        placeholderText="MM/dd/yyyy"

                        calendarContainer={CalendarStartContainer}
                        open={isStartOpen}
                        onFocus={() => setIsStartOpen(true)}
                        onInputClick={() => setIsStartOpen(true)}
                        onClickOutside={() => setIsStartOpen(false)}
                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                                <div>
                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                        {"<"}
                                    </button>
                                    <select
                                        value={selectedMonth}
                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                    >
                                        {getMonths(selectedYear)}
                                    </select>
                                    <select
                                        value={selectedYear}
                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                    >
                                        {Array.from({ length: 100 }, (v, k) => (
                                            <option key={k} value={new Date().getFullYear() - k}>
                                                {new Date().getFullYear() - k}
                                            </option>
                                        ))}
                                    </select>
                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                        {">"}
                                    </button>
                                </div>
                            );
                        }}
                    />
                </div>

                <div className="datepicker-container" style={{ marginLeft: '20px', zIndex: 10 }}>
                    <label>To:</label>
                    <DatePicker
                        selected={endDate ? new Date(endDate) : null}
                        onChange={handleEndDateChange}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}
                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                        placeholderText="MM/dd/yyyy"
                        popperPlacement="bottom-start"

                        calendarContainer={CalendarContainer}
                        open={isEndOpen}
                        onFocus={() => setIsEndOpen(true)}
                        onInputClick={() => setIsEndOpen(true)}
                        onClickOutside={() => setIsEndOpen(false)}
                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                                <div>
                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                        {"<"}
                                    </button>
                                    <select
                                        value={selectedMonth}
                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                    >
                                        {getMonths(selectedYear)}
                                    </select>
                                    <select
                                        value={selectedYear}
                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                    >
                                        {Array.from({ length: 100 }, (v, k) => (
                                            <option key={k} value={new Date().getFullYear() - k}>
                                                {new Date().getFullYear() - k}
                                            </option>
                                        ))}
                                    </select>
                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                        {">"}
                                    </button>
                                </div>
                            );
                        }}
                    />
                </div>



                <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '1px', height: '30px'}}>
                    <FontAwesomeIcon style={{ marginLeft: '7px',cursor: 'pointer'}} onClick={handleGetGeneralDocsData} icon={faMagnifyingGlass} />
                </div>

            </div>



            <div className='remittance-table' style={{ backgroundColor: 'white', height: '100%' }}>
                <table className="table table-hover table-striped table-bordered border border-white responsive mt-1 " style={{width:'100%'}}>

                    <thead>

                        <tr className='align-top' >

                            <th className='col-sm col-th  text-white' style={{ backgroundColor: '#1a9b8c' }}>#</th>

                            <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c' }}>
                                <Link className='text-white'>Uploaded Date</Link>

                            </th>



                            <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c' }}>Document Name

                            </th>



                            <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c' }}>Notes

                            </th>



                            <th className='col col-th-style text-white ' style={{ backgroundColor: '#1a9b8c' }}>Delete


                            </th>


                            <th className='col col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>	Selected

                            </th>





                        </tr>


                    </thead>

                    <tbody>


                        {generalDocsData.length > 0 ? (
                            generalDocsData.map((item, index) => (
                                <tr key={index}
                                className={`${activeRow === index ? 'table-warning' : ''} ${'table-info'}`}

                                onClick={() => handleRowClick(index)}
                                >
                                    <td>{index + 1}</td>
                                    <td>{item.UploadedDateTime}</td>
                                    <td>{item.DocumentName}

                                        <FontAwesomeIcon style={{ marginLeft: '10px', color: 'red' }} onClick={() => GetPDF(item)} icon={faFilePdf} />
                                    </td>
                                    <td>

                                        <textarea
                                            type="text"
                                            value={item.Results || ""}  
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                        />

                                    </td>
                                    <td><FontAwesomeIcon style={{ cursor: 'pointer' }}  onClick={() => handleDeleteModal(item)} icon={faTrashCan} /></td>
                                    <td>
                                        <input
                                            type='checkbox'
                                            key={index}
                                            checked={selectedRows.includes(index)}
                                            onChange={() => handleRowCheckboxChange(index, item)}
                                        />

                                    </td>
                                </tr>
                            ))
                        ) : (

                            <>
                                <h5 style={{ fontSize: '1.1rem', width: '200px' }}>No Recoards Found!</h5>
                            </>

                        )}


                    </tbody>





                    {showConfirmModal && (

                    <div className='alert-modal'>

                    <p>Are you sure to delete ?</p>
                    <button className='btn btn-primary' onClick={handleCloseModals}>cancel</button>
                    <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={handleDelete} >Delete</button>
                    </div>
                    )}




                </table>









            </div>

  </div>



        </>
    )
}

export default GeneralDocuments;